import { Fragment } from 'react';
import Icon from 'components/Icon';
import Head from 'components/Head';
import { getMeta } from 'constants/meta';

const OurValues = ({ location }) => {
  const { title, description } = getMeta(location.pathname);
  return (
    <Fragment>
      <Head title={title} description={description} />
      <article className="section__article section__article_tab_2">
        <section className="section section_values_1">
          <div className="wrapper">
            <div className="section__header-wrap _mb-74 _mb-note-32">
              <h2 className="title title_size_m _mb-18">Our Core Values</h2>
              <p className="text text_size_l_old section__main-text">
                Jump into an exciting and fast-paced environment.
              </p>
            </div>
            <div className="row">
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-87" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Teamwork</h5>
                  <p className="text">
                    Working openly and collaboratively, demonstrating respect
                    for all colleagues whilst achieving our goals.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-88" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Innovation</h5>
                  <p className="text">
                    Encouraging research and development of new products,
                    services or techniques that can positively change the way we
                    think and do things.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-89" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Creativity</h5>
                  <p className="text">
                    The culmination of ideas and thoughts, using imagination for
                    inventiveness and ongoing improvement.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-90" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Excellence</h5>
                  <p className="text">
                    Doing everything to the best of our ability and excelling in
                    pursuit of market leadership.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-91" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Efficiency</h5>
                  <p className="text">
                    Consistently demonstrating the clever use of time and
                    resources to deliver optimal results.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-portrait-12">
                <div className="_mb-72 _mb-note-42">
                  <div className="section__icon-wrap _mb-11">
                    <Icon icon="icon-92" />
                  </div>
                  <h5 className="title title_size_xs_old _mb-8">Integrity</h5>
                  <p className="text">
                    Being real, authentic, reliable and ethical. We aim to
                    always do the right thing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    </Fragment>
  );
};

export default OurValues;
